import React from 'react';
import { Tabs, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PaymentSettings from './PaymentSettings';
import './UserSettings.css';

const UserSettings = () => {
  const navigate = useNavigate();
  
  const items = [
    {
      key: '1',
      label: 'Payment Settings',
      children: <PaymentSettings />,
    },
  ];

  return (
    <div className="container-fluid">
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <div style={{ marginBottom: '16px' }}>
              <Button
                type="default"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate('/user/admin-dashboard')}
                style={{ marginBottom: '10px' }}
              >
                Back to Dashboard
              </Button>
            </div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/user/admin-dashboard">Dashboard</a>
              </li>
              <li className="breadcrumb-item">
                <i className="feather-chevron-right"></i>
              </li>
              <li className="breadcrumb-item active">Settings</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <Tabs defaultActiveKey="1" items={items} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettings;